import {Button} from "reactstrap";
import React from "react";
import {
    CANCEL,
    EDIT,
    NEW,
    SAVE,
    ADD,
    ASG_ROLE,
    PERM,
    DELETE,
    SCHEDULE,
    ASG_PERM,
    CHANGE,
    SEARCH,
    CLEAN,
    FILTERS,
    SHOW,
    HIDE,
    GALLERY,
    REFRESH,
    PROGRAM,
    UDN,
    MENUS,
    ACTIVITY,
    CLOSE,
    ACCEPT,
    REJECT,
    RETURN,
    OK,
    LIST_VIEW,
    MAP_VIEW,
    CALENDAR_VIEW,
    BENEFIT,
    TABOPTION,
    CANVAS_VIEW,
    PRODUCTS,
    SYNC,
    PRICES,
    UPD_PRICES,
    NEAR_PLACE,
    AWARDS,
    TOOLTIP_EDIT_AMENITIES,
    TOOLTIP_EDIT_ROOM_PLACE,
    TOOLTIP_EDIT_PLACE_ROOM,
    VIEW_DETAIL, ACTIVITIES, LB_CONFIRM, LB_REMOVE
} from "../i18n/i18n";
import Tooltip from "@material-ui/core/Tooltip";

export const hasPermission = (option) => {
    if(!option)
        return true

    let result = false
    let perm = (localStorage.getItem('permission') != '' ? JSON.parse(localStorage.getItem('permission')) : null);
    if (perm != null) {
        switch (option) {
            case "add":
                result = perm.allowAdd;
                break;
            case "edit":
                result = perm.allowEdit;
                break;
            case "delete":
                result = perm.allowDelete;
                break;
            case "gallery":
                result = perm.allowGallery;
                break;
            case "schedule":
                result = perm.allowSchedule;
                break;
            case "sync_firebase":
                result = perm.allowSync;
                break;
            case "prices":
                result = perm.allowPrices;
                break;
            case "search":
                result = perm.allowSearch;
                break;
        }
    }
    return result;
}

export const ButtonAdd = ({onClick}) => {
    return (
        <Button type="submit" className="btn-add ml-2" onClick={onClick}>
            {ADD} <i className="fas fa-plus btn-icon"/>
        </Button>
    )

}

export const ButtonAdd2 = ({onClick}) => {
    return (
        <Button type="button" className="btn-add ml-2" onClick={onClick}>
            {ADD} <i className="fas fa-plus btn-icon"/>
        </Button>
    )
}

export const ButtonNew = ({onClick} = null) => {
    let permission = hasPermission("add");
    if (permission) {
        return (
            <Button type="button" className="btn-add ml-auto" onClick={onClick}>
                {NEW} <i className="fas fa-plus-circle btn-icon"/> </Button>
        )
    } else {
        return null;
    }
}

export const ButtonEdit = ({onClick, submit= false}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Button type={submit ? 'submit' : 'button'} className="btn-edit ml-2" onClick={onClick}>
                {EDIT} <i className="fas fa-pen btn-icon"/> </Button>
        )
    } else {
        return null;
    }
}

export const ButtonSync = ({onClick} = null) => {
    let permission = hasPermission("sync_firebase");
    if (permission) {
        return (
            <Button type="button" className="btn-sync ml-auto" onClick={onClick}>
                {SYNC} <i className="fas fa-sync btn-icon"/> </Button>
        )
    } else {
        return null;
    }
}
export const ButtonUpdPrices = ({onClick} = null) => {
    let permission = hasPermission("prices");
    if (permission) {
        return (
            <Button type="button" className="btn-sync ml-2" onClick={onClick}>
                {UPD_PRICES} <i className="fas fa-dollar-sign btn-icon"/> </Button>
        )
    } else {
        return null;
    }
}

export const ButtonEditPermissions = ({onClick}) => {
    return (
        <Button className="btn-edit ml-2" onClick={onClick}>
            {PERM} <i className="fas fa-lock-open btn-icon"/> </Button>
    )
}

export const ButtonEditRole = ({onClick}) => {
    return (
        <Button className="btn-edit ml-2" onClick={onClick}>
            {ASG_ROLE} <i className="fas fa-users-cog btn-icon"/> </Button>
    )
}

export const ButtonEditSchedule = ({onClick}) => {
    let permission = hasPermission("schedules");
    if (permission) {
        return (
            <Button className="btn-edit ml-2" onClick={onClick}>
                {SCHEDULE} <i className="fas fa-clock btn-icon"/> </Button>
        )
    } else {
        return null;
    }
}

export const ButtonSave = ({onClick, disabled= false, loading = false}) => <Button  disabled={ disabled } className="btn-add ml-auto ml-2" onClick={onClick}>
 {SAVE} <i className={ loading ? 'fa fa-spinner fa-spin' : 'fas fa-save btn-icon'}/>
</Button>



export const ButtonDelete = ({onClick, disabled}) => {
    return (
        <Button className="btn-danger ml-auto ml-2" onClick={onClick} disabled={disabled}>
            {DELETE} <i className="fas fa-trash btn-icon"/></Button>
    )
}

export const ButtonSubmit = ({onClick, disabled = false}) => {
    return (
        <Button disabled={disabled} type={"submit"} className="btn-add ml-auto ml-2" onClick={onClick}>
            {SAVE} <i className="fas fa-save btn-icon"/></Button>
    )
}

export const ButtonSubmitPassword = ({onClick}) => {
    return (
        <Button type={"submit"} className="btn-add ml-auto ml-2" onClick={onClick}>
            {CHANGE} <i className="fas fa-key btn-icon"/></Button>
    )
}

export const GenericButton = ({onClick, title, icon = 'fa-key'}) => {
    return (
        <Button className="btn-cancel ml-auto ml-2" onClick={onClick}>
            {title}
            { icon && <i className={"fas btn-icon " + icon}/> }
        </Button>
    )
}

// Estas madres están invertidas
export const ButtonCancel = ({onClick, size = null, title = CLOSE}) => {
    return (
        <Button type={"button"} size={size} className="btn-cancel ml-auto ml-2" onClick={onClick}>{title}  </Button>
    )
}

export const ButtonReturn = ({onClick}) => {
    return (
        <Button className="btn-cancel ml-2" onClick={onClick}>{RETURN}  </Button>
    )
}

export const ButtonCancel2 = ({onClick}) => {
    return (
        <Button className="btn-cancel ml-2" onClick={onClick}>{CANCEL}  </Button>
    )
}

export const ButtonOk = ({onClick}) => {
    return (
        <Button className="btn-add ml-2" onClick={onClick}>{OK}  </Button>
    )
}

export const ButtonAccept = ({onClick, size=null}) => {
    return (
        <Button size={size} className="btn-add ml-2" onClick={onClick}>{ACCEPT}  </Button>
    )
}

export const ButtonReject = ({onClick, size=null}) => {
    return (
        <Button size={size} className="btn-danger ml-2" onClick={onClick}>{REJECT}  </Button>
    )
}

export const ButtonFilter = ({onClick}) => {
    return (
        <Button className="btn-cancel ml-2" onClick={onClick}>
            {FILTERS} <i className="fas fa-filter btn-icon"/>
        </Button>
    )
}

export const ButtonSearch = ({onClick}) => {
    return (
        <Button type={"submit"} className="btn-cancel ml-2" onClick={onClick}>
            {SEARCH} <i className="fas fa-search btn-icon"/>
        </Button>
    )
}

export const ButtonClean = ({
onClick = () => console.warn('With out function'),
icon = 'fas fa-undo btn-icon'
}) => <Button className="btn-cancel ml-2" onClick={onClick}>
    {CLEAN} <i className={icon} />
</Button>

export const ButtonTablePriceProduct = ({onClick}) => {
    let permission = hasPermission("prices");
    if (permission) {
        return (
            <Tooltip title={UPD_PRICES} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-dollar-sign"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableDelete = ({onClick}) => {
    let permission = hasPermission("delete");
    if (permission) {
        return (
            <Tooltip title={DELETE} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-trash"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEdit = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={EDIT} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i  className="fas fa-pen"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditActivities = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={ACTIVITIES} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i  className="fas fa-bicycle"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableGeoPickup = ({onClick}) => {
    // let permission = hasPermission("geo");
    let permission = true;
    if (permission) {
        return (
            <Tooltip title={EDIT} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-map-marked-alt"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableAwards = ({onClick}) => {
    // let permission = hasPermission("awards");
    let permission = true;
    if (permission) {
        return (
            <Tooltip title={AWARDS} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-trophy"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditAmenities = ({onClick}) => {
    // let permission = hasPermission("amenity");
    let permission = true;
    if (permission) {
        return (
            <Tooltip title={TOOLTIP_EDIT_AMENITIES} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-chess"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditRoomPlace = ({onClick}) => {
    // let permission = hasPermission("amenity");
    let permission = true;
    if (permission) {
        return (
            <Tooltip title={TOOLTIP_EDIT_ROOM_PLACE} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-building"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditPlaceRoom = ({onClick}) => {
    // let permission = hasPermission("amenity");
    let permission = true;
    if (permission) {
        return (
            <Tooltip title={TOOLTIP_EDIT_PLACE_ROOM} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-bed"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditBenefit = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={BENEFIT} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-cart-plus"/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditTabOptions = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={TABOPTION} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-columns"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const GenericTableButton = ({
    toolTip,
    icon,
    permission,
    onClick,
    disabled = false,
    type = 'button',
    clazz = '',
    iconClazz=''
}) => {
    if (!hasPermission(permission))
        return

    return <Tooltip title={toolTip} placement="bottom">
        <Button className={`${clazz} btn-actions-table ml-2`} onClick={onClick} disabled={disabled} type={type}>
            <i className={`fas ${icon} ${iconClazz} `} />
        </Button>
    </Tooltip>
}

export const CustomMiniButtonX = ({toolTip, icon, permission, onClick, disabled = false}) => {
    if (hasPermission(permission)) {
        return (
            <Tooltip title={toolTip} placement="bottom">
                <Button className="custom-mini-button-x ml-2" onClick={onClick} disabled={disabled}>
                    <i className={"fas " + icon}/>
                </Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableEditProducts = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={PRODUCTS} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-box-open"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableViewPrices = ({onClick}) => {
    let permission = hasPermission("prices");
    if (permission) {
        return (
            <Tooltip title={PRICES} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-dollar-sign"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}
export const ButtonTableView = ({onClick}) => {
    return (
        <Tooltip title={VIEW_DETAIL} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-eye"/></Button>
        </Tooltip>
    )
}


export const ButtonTableAdmActivity = ({onClick}) => {
    let permission = hasPermission("edit");
    if (permission) {
        return (
            <Tooltip title={ACTIVITY} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-sign"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonListView = ({onClick}) => {
    return (
        <Tooltip title={LIST_VIEW} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-list"/></Button>
        </Tooltip>
    )
}

export const ButtonMapView = ({onClick, disabled}) => {
    return (
        <Tooltip title={MAP_VIEW} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick} disabled={disabled}><i
                className="fas fa-map-marked"/></Button>
        </Tooltip>
    )
}

export const ButtonCanvasView = ({onClick, disabled}) => {
    return (
        <Tooltip title={CANVAS_VIEW} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick} disabled={disabled}><i
                className="fas fa-th"/></Button>
        </Tooltip>
    )
}

export const ButtonCalendarView = ({onClick}) => {
    return (
        <Tooltip title={CALENDAR_VIEW} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-calendar"/></Button>
        </Tooltip>
    )
}

export const ButtonRefresh = ({onClick}) => {

    return (
        <Tooltip title={REFRESH} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}>
                <i className="fas fa-retweet"/>
            </Button>
        </Tooltip>
    )
}

export const ButtonCollapseEye = ({onClick, status}) => {
    if (status) {
        return (
            <Tooltip title={HIDE} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-eye"/>
                </Button>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title={SHOW} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}>
                    <i className="fas fa-eye-slash"/>
                </Button>
            </Tooltip>
        )
    }
}

export const ButtonTableFilter = ({onClick, collapsed}) => {
    let msg = HIDE;
    if (!collapsed)
        msg = SHOW;
    return (
        <Tooltip title={msg} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}>
                {FILTERS} <i className="fas fa-filter"/></Button>
        </Tooltip>
    )
}

export const ButtonTableSchedule = ({onClick}) => {
    let permission = hasPermission("schedule");
    if (permission) {
        return (
            <Tooltip title={SCHEDULE} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-clock"/></Button>
            </Tooltip>

        )
    } else {
        return null;
    }
}

export const ButtonTableGellery = ({onClick}) => {
    let permission = hasPermission("gallery");
    if (permission) {
        return (
            <Tooltip title={GALLERY} placement="bottom">
                <Button className="btn-actions-table ml-2" onClick={onClick}><i
                    className="fas fa-image"/></Button>
            </Tooltip>
        )
    } else {
        return null;
    }
}

export const ButtonTableProgram = ({onClick}) => {
    return (
        <Tooltip title={PROGRAM} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-clipboard-list"/></Button>
        </Tooltip>
    )
}

export const ButtonTableUdn = ({onClick}) => {
    return (
        <Tooltip title={UDN} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-building"/></Button>
        </Tooltip>
    )
}

export const ButtonTableNearPlace = ({onClick}) => {
    return (
        <Tooltip title={NEAR_PLACE} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-building"/></Button>
        </Tooltip>
    )
}

export const ButtonTableMenu = ({onClick}) => {
    return (
        <Tooltip title={MENUS} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-bars"/></Button>
        </Tooltip>
    )
}


export const ButtonTableEditChild = ({onClick}) => {
    return (
        <Tooltip title={ASG_ROLE} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-users-cog"/></Button>
        </Tooltip>
    )
}

export const ButtonTablePerm = ({onClick}) => {
    return (
        <Tooltip title={ASG_PERM} placement="bottom">
            <Button className="btn-actions-table ml-2" onClick={onClick}><i
                className="fas fa-lock-open"/></Button>
        </Tooltip>

    )
}

export const ButtonTableLog = ({onClick}) => {
    return (
        <Button className="btn-actions-table ml-2" onClick={onClick}><i
            className="fas fa-search-plus"/></Button>
    )
}

export const TranslateButton = ({onClick}) => <Tooltip title={'Traducir'} placement="bottom">
    <Button className="btn-actions-table ml-2" onClick={onClick}>
        <i className="fa fa-language"/>
    </Button>
</Tooltip>


export const ButtonConfirm = ({onClick}) => <Button type="submit" className="btn-add ml-2" onClick={onClick}>
    {LB_CONFIRM}
</Button>

export const ButtonRemove = ({onClick}) => <Button type="submit" className="btn-cancel ml-2" onClick={onClick}>
    {LB_REMOVE}
</Button>


export const ButtonSearchDinamic = ({onClick, loading = false}) => <Button
    disabled={loading}
    type={"submit"}
    className="btn-add ml-auto ml-2"
    onClick={onClick}
>
            {SEARCH} <i className={`fas ${ loading ? 'fa-spinner fa-spin' : 'fa-search'} btn-icon`} aria-hidden="true" />
</Button>

export const CustomButton = ({
    type = 'button',
    loading = false,
    title =  `${SAVE}`,
    icon = '',
    onClick = () => console.warn('with out function'),
    disabled = false,
    clazz=''
 }) => <Button
    disabled={loading || disabled}
    type={ type }
    className={`btn-add ml-auto ml-2 ${clazz}`}
    onClick={onClick}
>
    { title } <i className={`${ loading ? 'fa-spinner fa-spin' : icon} btn-icon`} aria-hidden="true" />
</Button>

export const CustomIconButton = ({
    clazz = '',
    icon = 'fa fa-shield',
    permission = null,
    onClick = () => console.warn('with out function')
}) => {
    if(!hasPermission(permission))
        return

    return <div className={ `${clazz}` } onClick={ onClick }>
        <i className={ `${icon}` } />
    </div>
}